import React, { PureComponent } from 'react';

import { View, WebView, Platform, TouchableOpacity } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import Modal from '@dbk/ui-modal';
import moment from 'moment';
import 'moment/min/locales';
import Text from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import InverseProvider from '@dbk/ui-inverse';
import { addDays, addMonths, ymd } from '../../../../src/utils/date';

class DateRangeSelector extends PureComponent {
    constructor(props) {
        super(props);
        const { maturities: { fromDate, toDate } } = props;

        const languageCode = this.props.auth.langCode;
        this.state = {
            values: {
                  from: fromDate ? moment(ymd(fromDate)).toDate() : null,
                to: toDate ? moment(ymd(toDate)).toDate() : null
            }
        }

    }

    componentWillUnmount() {
        // this.props.maturities.setShowDateRange(false);
    }

    componentDidUpdate(){
        if (this.props.reports.closeDatePicker === true && this.datepickerRef && this.datepickerRef.datepicker && this.datepickerRef.datepicker.state && this.datepickerRef.datepicker.state.isOpen ) {
          this.onCancel();
        }
        if(this.state.values.from && this.state.values.to){
            setTimeout(() => {
                if(document.querySelector('#applybtnFocus')){
                    document.querySelector('#applybtnFocus').focus();
                }
            }, 100);
        }
      }

    onCancel = () => {
        this.datepickerRef.close();
        this.props.setDatePickerClose(false);
    }

    hideDateRangeModal = () => {
        this.datepickerRef.close();
    }


    // onDayClick = (selectionStart) => {
    //     const value = Utils.addDayToRange(selectionStart, this.state.dateRange);
    //     this.setState({
    //         dateRange: value
    //     });
    // }

    // onDayClick = (day) => {
    //     const range = Utils.addDayToRange(day, { ...this.state.dateRange });
    //     this.setState({
    //         dateRange: {
    //             ...Utils.updateRangeWithReset(this.state.dateRange, range)
    //         }
    //     })
    // }

    onChangeRange = (range) => {
        this.setState({
            values: {
                ...range
            }
        });
    };

    onDateApply = () => {
        const { values: { from, to } } = this.state;
        this.props.maturities.customDate = false;
        this.props.maturities.onCalendarDone({
            fromDate: from ? moment(from).format('YYYY-MM-DD') : null,
            toDate: to ? moment(to).format('YYYY-MM-DD') : null
        });
        this.datepickerRef.close();
    }

    customFooter = () => {
        const { i18n: { messages }, portfolio: { overallMarketValue: { asOfDate } } } = this.props;
        const { values: { from, to } } = this.state;
        return <InverseProvider inverse className="customFooterParent">
            <div className="customFooterBody" tabIndex={0}>
                <Text className="customFooterToday">{messages['app.calendar.today']}{from ? moment(from).format('DD-MMM-YYYY') : moment(asOfDate).format('DD-MMM-YYYY')}</Text>
            </div>
            <div className="datepicker-footer-btn">
                <Button tertiary
                    onClick={() => this.hideDateRangeModal()}
                >{messages['app.profile.changeLanguage.cancelText']}</Button>

                <Button
                    id="applybtnFocus"
                    onClick={() => this.onDateApply()}
                    disabled={!(from && to)}
                >{messages['app.calendar.apply']}</Button>
            </div>
        </InverseProvider>
    }


    render() {
        const { values } = this.state;
        const { i18n: { messages }, portfolio: { overallMarketValue: { asOfDate } } } = this.props;
        return (
            <div className='input-container'>
                { !this.props.logoutPopup.isVisible && <DatePicker
                    ref={(ref) => this.datepickerRef = ref}
                    tetherProps={{attachment : "left center"}}
                    showOutsideMonthDays={false}
                    enableYearNavigation
                    enableRangeSelection
                    onChange={this.onChangeRange}
                    value={values}
                    startDate={moment(ymd(asOfDate)).toDate()}
                    endDate={moment(ymd(asOfDate)).add(1, 'year').toDate()}
                    navigationDate={(this.state.values && this.state.values.from) ? this.state.values.from : moment(ymd(asOfDate)).toDate()}
                    selectionStart={values.from}
                    selectionEnd={values.to}
                    disableWeekendDays
                    inputDateFormat={'dd MMM yyyy'}
                    rangeSeparator={' - '}
                    // disablePastDays
                    renderFooter={() => this.customFooter()} 
                    locale={this.props.auth.langCode}
                    weekStartsOn={1} // Monday is the first day of the week.
                    />}
            </div>

        )
    }
}

export default createContainer({
    $queries: {
        maturities: {
            fromDate: true,
            toDate: true,
            onCalendarDone: { $call: 'onCalendarDone' },
            showDateRange: true,
            setShowDateRange: { $set: 'showDateRange' },
            customDate: true,
        },
        reports:{
            closeDatePicker:true
        },
        setDatePickerClose: {
            $set: 'reports.closeDatePicker'
          },
        i18n: {
            messages: true,
        },
        auth: {
            langCode: true,
        },
        portfolio:{
            overallMarketValue:{
              asOfDate: true,
            },
        },
        logoutPopup: {isVisible : true},
    },

})(DateRangeSelector);
